"use client";

import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from "@workspace/ui/components/card";
import React from "react";

interface ArtistErrorBoundaryState {
	hasError: boolean;
	error?: Error;
}

export class ArtistErrorBoundaryWrapper extends React.Component<
	React.PropsWithChildren,
	ArtistErrorBoundaryState
> {
	constructor(props: React.PropsWithChildren) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error: Error): ArtistErrorBoundaryState {
		return { hasError: true, error };
	}

	componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
		console.error("Artist content error:", error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			return (
				<Card className="border-destructive/50">
					<CardHeader>
						<CardTitle className="text-destructive">
							Something went wrong
						</CardTitle>
					</CardHeader>
					<CardContent>
						<p className="text-sm text-muted-foreground">
							Unable to load artist content. Please try refreshing the page.
						</p>
						{this.state.error && (
							<details className="mt-4">
								<summary className="cursor-pointer text-xs text-muted-foreground">
									Error details
								</summary>
								<pre className="mt-2 overflow-auto rounded bg-muted p-2 text-xs">
									{this.state.error.message}
								</pre>
							</details>
						)}
					</CardContent>
				</Card>
			);
		}

		return this.props.children;
	}
}
